import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const startedAt = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - startedAt) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (v: number) => String(v).padStart(2, "0");

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
